export const TITKOK_ACCESS_DENIED_MESSAGE = 'access_denied';
